import { z } from "zod";
import { slugString } from "./slug.js";

export const MuscleRegion = z.enum([
  "lower",
  "posterior",
  "chest",
  "back",
  "shoulders",
  "arms",
  "core",
  // Not anatomical strictly, but the catalog UX treats cardio as a
  // first-class region chip so users can browse / filter it the same
  // way they pick "chest" or "back". Antenore requested 2026-05-18
  // after the 1.66.9 cardio Logger landed and cardio exercises stayed
  // hidden because exerciseRegion() couldn't classify them.
  "cardio",
]);
export type MuscleRegion = z.infer<typeof MuscleRegion>;

// Display names ship in five locales mirrored to the rest of the app.
// Adding a sixth requires a new entry on every Muscle row, so the schema
// stays strict on the keys and rejects partial translations.
export const MuscleNames = z.object({
  en: z.string().min(1),
  it: z.string().min(1),
  fr: z.string().min(1),
  de: z.string().min(1),
  ru: z.string().min(1),
});
export type MuscleNames = z.infer<typeof MuscleNames>;

export const Muscle = z.object({
  slug: slugString(64),
  names: MuscleNames,
  region: MuscleRegion,
});
export type Muscle = z.infer<typeof Muscle>;

export const MovementPattern = z.enum([
  "squat",
  "hinge",
  "horizontal-push",
  "vertical-push",
  "horizontal-pull",
  "vertical-pull",
  "lunge",
  "carry",
  "core",
  "isolation",
  // Lavoro di mobilita': lo scopo e' l'escursione articolare, non il carico.
  // Sua parola del 10/09 sui wall angel: «non sono ne' pull ne' push, sono
  // esercizi di mobilita' e vanno categorizzati cosi'». ⛔ Non ci finisce ogni
  // riga col tag `mobility`: un divebomber push-up o un windmill restano il
  // movimento caricato che sono.
  "mobility",
  "cardio",
  "other",
]);
export type MovementPattern = z.infer<typeof MovementPattern>;

export const EquipmentKind = z.enum([
  "barbell",
  "dumbbell",
  "kettlebell",
  "cable",
  "machine",
  "bodyweight",
  "band",
  // Cardio gear added 1.62.0 with the cardio LogSet kind. Granular
  // values (treadmill vs exercise-bike) rather than a single
  // "cardio-machine" bucket so future filters and per-equipment
  // defaults (rest, units, intervals) can stay precise.
  "treadmill",
  "exercise-bike",
  "elliptical",
  "rower",
  "stair-climber",
  "jump-rope",
  "battle-ropes",
  "sled",
  "other",
]);
export type EquipmentKind = z.infer<typeof EquipmentKind>;
